import React from "react";

export const PartialReplacementIcon = (props: any) => (
    <svg
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
        style={{ height: "100%", ...props.style }}
        {...props}
    >
        <path
            d="M20,2 A18,18 0 0,0 20,38 L20,20 Z"
            fill="rgb(99, 99, 99)"
            stroke="white"
            strokeWidth="2"
        />
        <path
            d="M20,2 A18,18 0 0,1 20,38 L20,20 Z"
            fill="none"
            stroke="white"
            strokeWidth="2"
        />
        <circle
            cx="20"
            cy="20"
            r="18"
            fill="none"
            stroke="#9d9d9d"
            strokeWidth="1"
        />
    </svg>
);